import { NgModule } from '@angular/core';
import {
	CommonModule,
	DatePipe,
	TitleCasePipe,
	registerLocaleData
} from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CustomDateFormatter } from './utils/custom-date-formatter';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import localeFr from '@angular/common/locales/fr';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from '../core/footer/footer.component';
import { NgxBootstrapModule } from './modules/ngx-bootstrap.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CarouselModule } from 'ngx-bootstrap/carousel';

import { FilterBeneficiairesByNamePipe } from './pipes/filterBeneficiaires/filter-beneficiaires-by-name.pipe';
import { FilterFormationsByDatePipe } from './pipes/filterFormations/filter-formation-by-date.pipe';
import { FilterFormationBySkillPipe } from './pipes/filterFormations/filter-formation-by-skill.pipe';
import { FilterFormationBySpecialityPipe } from './pipes/filterFormations/filter-formation-by-speciality.pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { JwtModule } from '@auth0/angular-jwt';
import { LoadingComponent } from './components/loading/loading.component';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ExportPdfUtils } from './utils/export-pdf-utils';
import { FilterMissionPlaceBySpecialityPipe } from './pipes/filter-mission-place/filter-mission-place-by-speciality.pipe';
import { MinutesToTimePipe } from './pipes/timeConverters/minutes-to-time.pipe';
import { DateUtils } from './utils/date-utils';
import { ConvertObjectToCalendarEvent } from './utils/convert-object-to-calendar-event';
import { FilterUsersByEmployeeNamePipe } from './pipes/filterEmployee/filter-employees-by-name/filter-employees-by-name.pipe';
import { FilterSpecialitesByNamePipe } from './pipes/filter-specialites-by-name/filter-specialites-by-name.pipe';
import { FilterMissionsByDatePipe } from './pipes/filter-missions-by-date/filter-missions-by-date.pipe';
import { RecurringEventPickerComponent } from './components/recurring-event-picker/recurring-event-picker.component';
import { ToastComponent } from './components/toast/toast.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxEchartsModule } from 'ngx-echarts';
import { NoDataAvailableComponent } from './components/no-data-available/no-data-available.component';
import { ValidInputComponent } from './components/valid-input/valid-input.component';

//ngx
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PaginationModule } from 'ngx-bootstrap/pagination';

import { OrderByPipe } from './pipes/order-by/order-by.pipe';
import { FilterFormationByAllFieldsPipe } from './pipes/filterFormations/filter-formation-by-all-fields.pipe';
import { FilterEmployeeBySkillPipe } from './pipes/filterEmployee/filter-employee-by-skill/filter-employee-by-skill.pipe';
import { FilterEmployeeByAllFieldsPipe } from './pipes/filterEmployee/filter-employee-by-all-fields/filter-employee-by-all-fields.pipe';
import { FilterEmployeeBySpecialtiesPipe } from './pipes/filterEmployee/filter-employee-by-specialties/filter-employee-by-specialties.pipe';
import { FilterUserByLoginOrNameOrRolePipe } from './pipes/filterUsers/filter-user-by-login-or-name-or-role/filter-user-by-login-or-name-or-role.pipe';
import { FilterUserByRolePipe } from './pipes/filterUsers/filter-user-by-role/filter-user-by-role.pipe';
import { FilterVehiculeByAllFieldsPipe } from './pipes/filterVehicules/filter-vehicule-by-all-fields/filter-vehicule-by-all-fields.pipe';
import { FilterVehiculeByTravelledDistanceBetweenPipe } from './pipes/filterVehicules/filter-vehicule-by-travelled-distance-between/filter-vehicule-by-travelled-distance-between.pipe';
import { FilterVehiculeByMileageBetweenPipe } from './pipes/filterVehicules/filter-vehicule-by-mileage-between/filter-vehicule-by-mileage-between.pipe';
import { FilterVehiculeByStatusPipe } from './pipes/filterVehicules/filter-vehicule-by-status/filter-vehicule-by-status.pipe';
import { PaginatePipe } from 'ngx-pagination';
import { WeekSelectorComponent } from './components/week-selector/week-selector.component';
import { DaySelectorComponent } from './components/day-selector/day-selector.component';

import { MobileNavbarComponent } from '../core/navbar/mobile-navbar/mobile-navbar.component';
import { FilterMissionTypeByTypePipe } from './pipes/filterMissionTypeByType/filter-mission-type-by-type.pipe';
import { OrderByPipeNumber } from './pipes/order-by/order-by-number';
import { OrderByReportPipe } from './pipes/order-by/order-by-report.pipe';
import { StringUtils } from './utils/string-utils';
import { ResolveConflictModalComponent } from './components/resolve-conflict-modal/resolve-conflict-modal.component';
import { FilterMissionPlaceBySpecialtiesPipe } from './pipes/filter-mission-place/filter-mission-place-by-specialties/filter-mission-place-by-specialties.pipe';
import { FilterMissionPlaceByAllFieldsPipe } from './pipes/filter-mission-place/filter-mission-place-by-all-fields.pipe';
import { ConvertStateToStringPipe } from './pipes/convert-state-to-string.pipe';
import { SidebarComponent } from '../core/navbar/sidebar/sidebar.component';
import { TopbarComponent } from '../core/navbar/topbar/topbar.component';
import { NotificationManagerComponent } from '../core/navbar/notification-manager/notification-manager.component';
import { MessagingNotificationManagerComponent } from '../core/navbar/messaging-notification-manager/messaging-notification-manager.component';
import { ActivityReportComponent } from '../protected/reports/activity-report/activity-report.component';
import { FunderReportComponent } from '../protected/reports/funder-report/funder-report.component';
import { ActivityReportDetailComponent } from '../protected/reports/activity-report-detail/activity-report-detail.component';
import { ReportsComponent } from '../protected/reports/reports.component';
import { PlanningRepartitionComponent } from '../protected/statistiques/planning-repartition/planning-repartition.component';
import { SatisfactionUnassignedComponent } from '../protected/statistiques/satisfactions/satisfaction-unassigned/satisfaction-unassigned.component';
import { SatisfactionComponent } from '../protected/statistiques/satisfactions/satisfaction/satisfaction.component';
import { TravelDistanceByUserComponent } from '../protected/statistiques/travel-distances/travel-distance-by-user/travel-distance-by-user.component';
import { TravelDistanceDispersionComponent } from '../protected/statistiques/travel-distances/travel-distance-dispersion/travel-distance-dispersion.component';
import { TravelDistancePeriodicityComponent } from '../protected/statistiques/travel-distances/travel-distance-periodicity/travel-distance-periodicity.component';
import { TravelDistanceComponent } from '../protected/statistiques/travel-distances/travel-distance/travel-distance.component';
import { WorkingTimeByUserComponent } from '../protected/statistiques/working-times/working-time-by-user/working-time-by-user.component';
import { WorkingTimeDispersionComponent } from '../protected/statistiques/working-times/working-time-dispersion/working-time-dispersion.component';
import { WorkingTimeComponent } from '../protected/statistiques/working-times/working-time/working-time.component';
import { StatistiquesComponent } from '../protected/statistiques/statistiques/statistiques.component';
import { FilterListViewByIdentityPipe } from './pipes/filter-list-view-by-identity/filter-list-view-by-identity.pipe';
import { FilterConversationBySenderIdentityPipe } from './pipes/filter-conversation-by-sender-identity/filter-conversation-by-sender-identity.pipe';
import { SortByMissionDatePipe } from './pipes/order-by/sort-by-mission-date.pipe';
import { VacationReportComponent } from '../protected/reports/vacation-report/vacation-report.component';

import { environment } from '../../environments/environment';
import { RecaptchaModule } from 'ng-recaptcha';
import { FilterEmployeeByDepartmentPipe } from './pipes/filterEmployee/filter-employee-by-department/filter-employee-by-department.pipe';
import { FilterBeneficiaireByDepartmentPipe } from './pipes/filterBeneficiaires/filter-beneficiaire-by-department/filter-beneficiaire-by-department.pipe';
import { FilterFormationByDepartmentPipe } from './pipes/filterFormations/filter-formation-by-department/filter-formation-by-department.pipe';
import { RapportActiviteComponent } from '../protected/reports/sae/rapport-activite/rapport-activite.component';

export function tokenGetter() {
	return localStorage.getItem('JWT_TOKEN');
}
registerLocaleData(localeFr);
@NgModule({
	declarations: [
		FooterComponent,
		FilterBeneficiairesByNamePipe,
		FilterFormationsByDatePipe,
		FilterFormationBySkillPipe,
		FilterFormationBySpecialityPipe,
		LoadingComponent,
		FilterMissionPlaceBySpecialityPipe,
		MinutesToTimePipe,
		FilterUsersByEmployeeNamePipe,
		FilterSpecialitesByNamePipe,
		FilterMissionsByDatePipe,
		RecurringEventPickerComponent,
		ToastComponent,
		NoDataAvailableComponent,
		ValidInputComponent,
		OrderByPipeNumber,
		OrderByReportPipe,
		FilterFormationByAllFieldsPipe,
		FilterEmployeeBySkillPipe,
		FilterEmployeeByAllFieldsPipe,
		FilterEmployeeBySpecialtiesPipe,
		FilterEmployeeByDepartmentPipe,
		FilterMissionPlaceByAllFieldsPipe,
		FilterMissionPlaceBySpecialtiesPipe,
		FilterUserByLoginOrNameOrRolePipe,
		FilterUserByRolePipe,
		FilterVehiculeByAllFieldsPipe,
		FilterVehiculeByTravelledDistanceBetweenPipe,
		FilterVehiculeByMileageBetweenPipe,
		FilterVehiculeByStatusPipe,
		FilterBeneficiaireByDepartmentPipe,
		WeekSelectorComponent,
		DaySelectorComponent,
		MobileNavbarComponent,
		FilterMissionTypeByTypePipe,
		ResolveConflictModalComponent,
		ConvertStateToStringPipe,
		SidebarComponent,
		TopbarComponent,
		NotificationManagerComponent,
		MessagingNotificationManagerComponent,
		ActivityReportComponent,
		FunderReportComponent,
		ActivityReportDetailComponent,
		RapportActiviteComponent,
		ReportsComponent,
		VacationReportComponent,
		SatisfactionComponent,
		WorkingTimeComponent,
		TravelDistanceComponent,
		PlanningRepartitionComponent,
		TravelDistanceDispersionComponent,
		WorkingTimeDispersionComponent,
		WorkingTimeByUserComponent,
		TravelDistanceByUserComponent,
		TravelDistancePeriodicityComponent,
		SatisfactionUnassignedComponent,
		StatistiquesComponent,
		FilterListViewByIdentityPipe,
		FilterConversationBySenderIdentityPipe,
		SortByMissionDatePipe,
		FilterFormationByDepartmentPipe
	],
	imports: [
		HttpClientModule,
		CommonModule,
		RouterModule,
		NgxBootstrapModule,
		FormsModule,
		FlatpickrModule.forRoot(),
		ReactiveFormsModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory
		}),

		JwtModule.forRoot({
			config: {
				tokenGetter
				// allowedDomains: ['example.com'],
				// disallowedRoutes: ['http://example.com/examplebadroute/'],
			}
		}),
		AccordionModule.forRoot(),
		BsDatepickerModule.forRoot(),
		TimepickerModule.forRoot(),
		LeafletModule,
		// NgbModule,
		BrowserAnimationsModule, // required animations module for toasts
		ToastrModule.forRoot({
			positionClass: 'toast-bottom-right',
			preventDuplicates: true,
			timeOut: 8000
		}), // ToastrModule added
		NgxEchartsModule.forRoot({
			echarts: () => import('echarts')
		}),
		BsDropdownModule.forRoot(),
		PaginationModule.forRoot(),
		CarouselModule.forRoot(),
		ReactiveFormsModule,
		OrderByPipe
	],
	exports: [
		RouterModule,
		CommonModule,
		NgxBootstrapModule,
		FormsModule,
		ReactiveFormsModule,
		FooterComponent,
		FilterBeneficiairesByNamePipe,
		FilterFormationsByDatePipe,
		FilterFormationBySkillPipe,
		FilterFormationBySpecialityPipe,
		AccordionModule,
		BsDatepickerModule,
		TimepickerModule,
		LoadingComponent,
		LeafletModule,
		FilterMissionPlaceBySpecialityPipe,
		MinutesToTimePipe,
		CalendarModule,
		FilterUsersByEmployeeNamePipe,
		FilterSpecialitesByNamePipe,
		FilterMissionsByDatePipe,
		RecurringEventPickerComponent,
		NgxEchartsModule,
		NoDataAvailableComponent,
		ValidInputComponent,
		OrderByPipe,
		OrderByPipeNumber,
		OrderByReportPipe,
		TypeaheadModule,
		FilterFormationByAllFieldsPipe,
		FilterEmployeeBySkillPipe,
		FilterEmployeeByAllFieldsPipe,
		FilterEmployeeBySpecialtiesPipe,
		FilterEmployeeByDepartmentPipe,
		FilterMissionPlaceByAllFieldsPipe,
		FilterMissionPlaceBySpecialtiesPipe,
		FilterUserByLoginOrNameOrRolePipe,
		FilterUserByRolePipe,
		FilterVehiculeByAllFieldsPipe,
		FilterVehiculeByTravelledDistanceBetweenPipe,
		FilterVehiculeByMileageBetweenPipe,
		FilterVehiculeByStatusPipe,
		FilterBeneficiaireByDepartmentPipe,
		WeekSelectorComponent,
		DaySelectorComponent,
		FilterMissionTypeByTypePipe,
		ResolveConflictModalComponent,
		ConvertStateToStringPipe,
		SidebarComponent,
		TopbarComponent,
		MobileNavbarComponent,
		NotificationManagerComponent,
		MessagingNotificationManagerComponent,
		ActivityReportComponent,
		FunderReportComponent,
		ActivityReportDetailComponent,
		ReportsComponent,
		SatisfactionComponent,
		WorkingTimeComponent,
		TravelDistanceComponent,
		PlanningRepartitionComponent,
		TravelDistanceDispersionComponent,
		WorkingTimeDispersionComponent,
		WorkingTimeByUserComponent,
		TravelDistanceByUserComponent,
		TravelDistancePeriodicityComponent,
		SatisfactionUnassignedComponent,
		StatistiquesComponent,
		FilterListViewByIdentityPipe,
		FilterConversationBySenderIdentityPipe,
		SortByMissionDatePipe,
		FilterFormationByDepartmentPipe,
		RapportActiviteComponent
	],
	providers: [
		DatePipe,
		TitleCasePipe,
		CustomDateFormatter,
		DateUtils,
		ExportPdfUtils,
		ConvertObjectToCalendarEvent,
		FilterFormationByAllFieldsPipe,
		FilterFormationBySkillPipe,
		PaginatePipe,
		StringUtils,
		SortByMissionDatePipe
	]
})
export class SharedModule {}
